// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SqUusNx2CMDF3Hq4Kw8o{width:492px}.aWVu4lZvWYoZcQ59h3to{margin-top:24px;align-items:flex-start}.g4Tz7cibF3UVpkwxlp4m{padding-left:12px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/calling/ui/Configure/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CAEF,sBACE,eAAA,CACA,sBAAA,CAEF,sBACE,iBAAA","sourcesContent":[".container {\n  width: 492px;\n}\n.declaration {\n  margin-top: 24px;\n  align-items: flex-start;\n}\n.textInput {\n  padding-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SqUusNx2CMDF3Hq4Kw8o`,
	"declaration": `aWVu4lZvWYoZcQ59h3to`,
	"textInput": `g4Tz7cibF3UVpkwxlp4m`
};
export default ___CSS_LOADER_EXPORT___;
